export enum EditTypes {
    None, MeasureFullscreen, MeasurePopup
}